import React from 'react';
import { Space, Switch, Typography } from 'antd';
import styles from './index.module.less';

const { Text } = Typography;

const Switcher = ({ left, right, onChange, size }) => {
  return (
    <div
      className={
        size === 'small'
          ? styles.switcher_container_small
          : styles.switcher_container
      }
    >
      <Space size="middle">
        <Text
          className={
            size === 'small'
              ? `sfprotext-medium font-12`
              : `sfprotext-medium font-15`
          }
        >
          {left}
        </Text>
        <Switch onChange={onChange} size={size} />
        <Text
          className={
            size === 'small'
              ? `sfprotext-medium font-12`
              : `sfprotext-medium font-15`
          }
        >
          {right}
        </Text>
      </Space>
    </div>
  );
};

export default Switcher;
